// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"2466845af29196c0","469":"0e785b558a2c0b64","931":"0e785b558a2c0b64"}[chunkId] + ".css";
};